import { render } from "./list.vue?vue&type=template&id=f3a98d48&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=f3a98d48&lang=less&scoped=scoped"
import "./list.vue?vue&type=style&index=1&id=f3a98d48&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a98d48"]])

export default __exports__